import * as FiIcons from 'react-icons/fi';

const {
  FiCalendar,
  FiActivity,
  FiType,
  FiSquare,
  FiHardDrive,
  FiMove,
  FiZap,
  FiThermometer,
  FiClock,
  FiDroplet,
  FiPackage
} = FiIcons;

export const calculators = [
  {
    id: 'age',
    title: 'Altersrechner',
    description: 'Geben Sie Ihr Geburtsdatum ein und erhalten Sie Ihr genaues Alter in Jahren, Monaten und Tagen.',
    icon: FiCalendar,
    iconBg: 'bg-gradient-to-br from-blue-500 to-blue-600'
  },
  {
    id: 'bmi',
    title: 'BMI-Rechner',
    description: 'Body-Mass-Index berechnen.',
    icon: FiActivity,
    iconBg: 'bg-gradient-to-br from-green-500 to-green-600'
  },
  {
    id: 'word-counter',
    title: 'Wortzähler',
    description: 'Zählt Wörter, Zeichen, Sätze und Zeilen.',
    icon: FiType,
    iconBg: 'bg-gradient-to-br from-purple-500 to-purple-600'
  },
  {
    id: 'area',
    title: 'Flächenumrechner',
    description: 'Umrechnung zwischen Quadratmetern, km², Acres usw.',
    icon: FiSquare,
    iconBg: 'bg-gradient-to-br from-orange-500 to-orange-600'
  },
  {
    id: 'data',
    title: 'Datenspeicherkonverter',
    description: 'Umrechnung von Bytes, KB, MB, GB, TB.',
    icon: FiHardDrive,
    iconBg: 'bg-gradient-to-br from-indigo-500 to-indigo-600'
  },
  {
    id: 'length',
    title: 'Längenkonverter',
    description: 'Meter, Kilometer, Zoll, Fuß, Meilen usw. umrechnen.',
    icon: FiMove,
    iconBg: 'bg-gradient-to-br from-teal-500 to-teal-600'
  },
  {
    id: 'speed',
    title: 'Geschwindigkeitswandler',
    description: 'km/h, mph, m/s, Knoten umrechnen.',
    icon: FiZap,
    iconBg: 'bg-gradient-to-br from-yellow-500 to-yellow-600'
  },
  {
    id: 'temperature',
    title: 'Temperaturumrechner',
    description: 'Celsius, Fahrenheit, Kelvin konvertieren.',
    icon: FiThermometer,
    iconBg: 'bg-gradient-to-br from-red-500 to-red-600'
  },
  {
    id: 'time',
    title: 'Zeitumrechner',
    description: 'Sekunden, Minuten, Stunden, Tage umrechnen.',
    icon: FiClock,
    iconBg: 'bg-gradient-to-br from-pink-500 to-pink-600'
  },
  {
    id: 'volume',
    title: 'Volumenkonverter',
    description: 'Liter, Milliliter, Gallonen, Tassen usw. umrechnen.',
    icon: FiDroplet,
    iconBg: 'bg-gradient-to-br from-cyan-500 to-cyan-600'
  },
  {
    id: 'weight',
    title: 'Gewichts- und Massenumrechner',
    description: 'Umrechnung von kg, g, lb, oz, Tonne usw.',
    icon: FiPackage,
    iconBg: 'bg-gradient-to-br from-emerald-500 to-emerald-600'
  }
];